import { GECKO_CONSTS } from '../../';
import { EventEmitter } from 'fbemitter';

class GeckoDialogService {
  static emitter = new EventEmitter();
  get emitter() {
    return GeckoDialogService.emitter;
  }
  set emitter(value) {
    GeckoDialogService.emitter = value;
  }

  params = {
    size: 'sm',
    backdrop: 'static',
    keyboard: false,
  };

  constructor() {
    // Create modal event emitter (if not already created)
    if (!this.emitter) this.emitter = new EventEmitter();
  }

  open(message, type) {
    return new Promise((resolve, reject) => {
      this.emitter.emit('open', message, type, this.params);

      this.emitter.once('dismiss', (data) => resolve());
      this.emitter.once('close', (data) => resolve(data));
    });
  }

  alert(message) {
    return this.open(message, GECKO_CONSTS.DIALOG_TYPE_ALERT);
  }

  confirm(message) {
    return this.open(message, GECKO_CONSTS.DIALOG_TYPE_CONFIRM);
  }
}

export default GeckoDialogService;
